import { useRef } from "react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { useContent, absoluteUrl } from "@/contexts/ContentContext";

export function ImageEditArea({ path, id, label = "Change image", className, style, children, testId }) {
  const { editMode, setPath, uploadImage, getByPath } = useContent();
  const inputRef = useRef(null);
  const value = getByPath(path);
  const hasImage = !!value;

  async function handleFile(e) {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    try {
      const url = await uploadImage(file);
      setPath(path, url);
    } catch {
      toast.error("Image upload failed, try again");
    }
  }

  return (
    <div
      id={id}
      className={cn("img-target", hasImage && "has-bg", className)}
      style={{ ...style, backgroundImage: hasImage ? `url(${absoluteUrl(value)})` : undefined }}
    >
      {children}
      {!hasImage && editMode && <div className="placeholder-hint">+ No image set</div>}
      {editMode && (
        <>
          <button type="button" className="img-edit-btn" onClick={() => inputRef.current.click()} data-testid={testId || `img-edit-${path}`}>
            {label}
          </button>
          <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden onChange={handleFile} />
        </>
      )}
    </div>
  );
}
